// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../.config/yarn/global/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body-card[data-v-7dfad460]{overflow-y:auto}", ""]);
// Exports
module.exports = exports;
